import React from "react";
import Rbac from "../../../utils/Rbac";
import { Notification } from "../../../utils";
import t from '../../helpers/t';
import {isViewVisible} from "../../../utils/ViewSettings";
import TasksView from "./components/TasksView";


export const rbac = new Rbac({
  _rbac: {
    "admin": {
      write: true,
      delete: true,
      editTask: true,
      readAll: true,
    },
    "manager": {
      write: true,
      delete: true,
      editTask: true,
      readAll: true,
    },
    "booking-manager": {
      write: true,
      delete: true,
      editTask: true,
      readAll: true,
    },
    "manager-location": {
      write: true,
      delete: true,
      editTask: true,
      readAll: true,
    },
    "mediator": {
      write: true,
      delete: false,
      editTask: true,
      readAll: false,
    },
    "garage-staff": {
      write: true,
      delete: false,
      editTask: true,
      readAll: false,
    },
    "guide": {
      write: false,
      delete: false,
      editTask: false,
      readAll: false,
    },
    "user": {
      write: false,
      delete: false,
      editTask: false,
      readAll: false,
    }
  }
});

export const TasksPage = props => {
  let _view = typeof props.view === 'undefined' || props.view === null ? 'index' : props.view;
  let indexView = isViewVisible('tasks','tasks') ? 'tasks' : '';
  return (
      <>
        {(_view === 'tasks' || (_view === 'index' && indexView === 'tasks')) &&
        <TasksView
            name={"tasks"}
            dispatch={props.dispatch}
            params={props.params}
            showNotification={showNotification}
        />
        }
      </>
  );
};

export const showNotification = (msgType, itemId, message = '') => {

  if (msgType === 'success') {
    new Notification({
      message : message !== '' ? message :t('saved_${a}',{a:t('task')},'capital')+' #'+ itemId,
      duration : 5000,
      type : 'success',
      closeable : true,
      icon : 'fi fi-check'
    });
  } else if (msgType === 'warning') {
    new Notification({
      message : message !== '' ? message : t('request_error',null,'capital'),
      duration : 5000,
      type : 'warning',
      closeable : true,
      icon : 'fi fi-x'
    });
  }
};